module.exports = __webpack_public_path__ + "img/logo.d9401ed7.png";